import React, { useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { login } from '@/services/auth';
import useStore from '@/store/store';
import useWindowSize from '@/utils/useWindowSize';
import { pushLogin, pushLogout } from '@/utils/useWebPush';
import http from '@/services/http';
import { RoutesNames } from '../../router/navigationRoutes';
import s from './login.module.css';

const Login = ({ onLoginCb, onLogoutCb }) => {
	const username = useRef();
	const password = useRef();

	const navigate = useNavigate();
	const location = useLocation();
	const { user, resetAll, login: storeLogin } = useStore();

	const size = useWindowSize();

	// const showDrift = user?.cityLocation?.id === 8 || user?.id === -1;

	const onLogin = async e => {
		e.preventDefault();

		try {
			const res = await login(username.current, password.current);

			if (!res?.error && !res?.data?.error && res?.data) {
				localStorage.setItem('token', res.data.token);
				storeLogin({ ...res.data });
				if (!import.meta.env.DEV) {
					pushLogin(res.data);
				}

				if (onLoginCb) {
					onLoginCb();
				}
				if (location.pathname === '/') {
					navigate(RoutesNames.LIVE);
				}
				// if (window?.drift) {
				//   // console.log("reee s login drift ", res.data);

				//   const name = res?.data?.name;

				//   if (showDrift) {
				//     window.drift.identify(`${res?.data.id}`, {
				//       // email: name,
				//       first_name: name,
				//       name: name,
				//     });
				//   }
				// }
			} else if (res?.data?.code === 119) {
				toast.error('Λάθος username ή κωδικός');
			} else if (res?.data?.code === 179) {
				toast.error('Δεν έχετε δικαίωμα πρόσβασης');
			} else {
				toast.error('Κάποιο πρόβλημα προέκυψε');
			}
		} catch (err) {
			console.log(err, 'err');
		}
	};

	const onLogout = () => {
		try {
			pushLogout();
			if (onLogoutCb) {
				onLogoutCb();
			}
		} catch (err) {
			console.log('unsubscribe err: ', err);
		}
		navigate('/', { replace: true });
		localStorage.removeItem('token');
		// storeLogout();
		// setUser(null);
		resetAll();
		http.removeToken();

		// router.replace("/");
	};

	// const { register, handleSubmit } = useForm();

	const isMobile = size?.width <= 860;

	return (
		<>
			{user?.token ? (
				<div className={`${!isMobile ? s.containerLoggedIn : s.containerLoggedInMobile}`}>
					<span className={s.displayName}>{user.displayName}</span>
					<button className={`${s.logout_button} ${isMobile ? s.mobile : ''}`} onClick={onLogout}>
						Αποσύνδεση
					</button>
				</div>
			) : (
				<form className={s.form} onSubmit={onLogin}>
					<input
						// {...register("username")}
						type='text'
						className={s.input}
						onChange={e => (username.current = e.target.value)}
						placeholder='Username'
					/>

					<input
						// {...register("password")}
						type='password'
						className={s.input}
						onChange={e => (password.current = e.target.value)}
						placeholder='Password'
					/>

					<button className={s.submitButton}>Είσοδος</button>
				</form>
			)}
		</>
	);
};

export default Login;
